export const systemCheckKeyMap = {
  "sc state": "System controller state",
  "md state": "Motor drive state",
  "bms state": "Battery management state",
  "up time": "Elapsed time from the last power up",
  "gps accuracy": "GPS accuracy",
  "vehicle id": "Vehicle ID",
};

export const moduleMap = {
  sc: "System Controller",
  md: "Motor Drive",
  bm: "Battery Management System",
};
